import React from 'react'
import Swal from 'sweetalert2';
import { Link } from "react-router-dom";
import Api from "../../services/Api";
import authAxios from "../../services/Token";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faAt, faCalendarAlt, faEdit, faHashtag, faTimes } from '@fortawesome/free-solid-svg-icons';

class Editar extends React.Component {
    constructor(props) {
        super(props);
    }
    state = {
        load: '',
        datosCargados: false,
        cliente_especial: [],
        departamentos: [],
        municipios: [],
        errores: []
    }
    cambioValor = (e) => {
        const state = this.state.cliente_especial;
        state[e.target.name] = e.target.value;
        this.setState({ cliente_especial: state });
    };
    verificarError(elemento) {
        return this.state.errores.indexOf(elemento) !== -1;
    }
    enviarDatos = (e) => {
        e.preventDefault();
        const nic = document.getElementById('nic').value;
        const nombre = document.getElementById('nombre').value;
        const ID_COD_DPTO = document.getElementById('ID_COD_DPTO').value;
        const ID_COD_MPIO = document.getElementById('ID_COD_MPIO').value;
        const direccion = document.getElementById('direccion').value;
        const ID_TIPO_FACTURACION = document.getElementById('ID_TIPO_FACTURACION').value;
        const tarifa = document.getElementById('tarifa').value;
        const valor_impuesto = document.getElementById('valor_impuesto').value;
        const fecha_anulacion = document.getElementById('fecha_anulacion').value;
        var errores = [];
        if (!nic) { errores.push("error_nic"); }
        if (!nombre) { errores.push("error_nombre"); }
        if (!ID_COD_DPTO) { errores.push("error_id_departamento"); }
        if (!ID_COD_MPIO) { errores.push("error_id_municipio"); }
        if (!direccion) { errores.push("error_direccion"); }
        if (!ID_TIPO_FACTURACION) { errores.push("error_id_tipo_facturacion"); }
        if (!tarifa) { errores.push("error_tarifa"); }
        if (!valor_impuesto) { errores.push("error_valor_impuesto"); }
        if (!fecha_anulacion) { errores.push("error_fecha_anulacion"); }
        let form = document.getElementById('form');
        let formData = new FormData(form);
        console.log(errores.length);
        Swal.showLoading();
        this.setState({ errores: errores });
        if (errores.length > 0) {
            return false;
        }
        authAxios.post("clientes_especiales/editar", formData)
            .then((datosRespuesta) => {
                console.log(datosRespuesta)
                Swal.close();
                Swal.fire(
                    'Clientes Especiales!',
                    datosRespuesta.data.msj,
                    'success'
                )
                this.props.history.push("/MasterClientesEspeciales");
            })
            .catch(console.log)
    }
    cargarMunicipios() {
        var id_departamento = document.getElementById('ID_COD_DPTO').value;
        Swal.showLoading();
        authAxios.get("municipios_visitas/buscardepartamento/" + id_departamento)
            .then((datosRespuesta) => {
                console.log(datosRespuesta);
                this.setState({ datosCargados: true, municipios: datosRespuesta.data, load: '' });
                Swal.close();
            })
            .catch(console.log);
    }
    componentDidMount() {
        Swal.showLoading();
        authAxios.get("clientes_especiales/ver/" + this.props.match.params.id)
            .then((datosRespuesta) => {
                Swal.showLoading();
                console.log(datosRespuesta);
                this.setState({ datosCargados: true,
                                cliente_especial: datosRespuesta.data.resultado,
                                load: '' });
                var id_departamento = datosRespuesta.data.resultado.ID_COD_DPTO;
                var id_municipio = datosRespuesta.data.resultado.ID_COD_MPIO;
                document.getElementById("ID_COD_DPTO").value = id_departamento;
                document.getElementById("ID_COD_MPIO").value = id_municipio;
            })
            .catch(console.log);
        authAxios.get("departamentos_visitas/index/0")
            .then((datosRespuesta) => {
                console.log(datosRespuesta);
                var status = datosRespuesta.data.status;
                if (status) {
                    Swal.fire('Token ha Expirado!', 'Vuelva a Iniciar Sesión', 'info');
                    window.localStorage.clear();
                    window.location.href = '/';
                }
                this.setState({ datosCargados: true, departamentos: datosRespuesta.data.data, load: '' });
                this.cargarMunicipios();
            })
            .catch(console.log);
    }
    render() {
        const { load, cliente_especial, departamentos, municipios } = this.state;
        return (
            <div className="content-wrapper">
                <div className="content">
                    <div className="container-fluid">
                        <br />
                        <div className="card">
                            <div className="card-header text-center">
                                {load ? (<b>{load}</b>) : (<b>EDITAR CLIENTE ESPECIAL</b>)}
                            </div>
                            <div className="card-body">
                                <form onSubmit={this.enviarDatos} id="form">
                                    <div className="row">
                                        <div className="col-xl-12">
                                            <div className='row g-3'>
                                                <div className="col-md-2">
                                                    <label htmlFor="nic">NIC</label>
                                                    <div className="input-group input-group-sm">
                                                        <input type="hidden" name="id" id="id" value={this.props.match.params.id} />
                                                        <input type="hidden" name="id_usuario" id="id_usuario" value={window.localStorage.getItem('idusuario')} />
                                                        <span className="input-group-text" id="inputGroupPrepend"><FontAwesomeIcon icon={faHashtag} /></span>
                                                        <input style={{ textTransform: 'uppercase' }} type="text" name="nic" id="nic" defaultValue={cliente_especial.NIC}
                                                            className={((this.verificarError("error_nic")) ? "is-invalid" : "") + " form-control form-control-sm"} placeholder="NIC" aria-describedby="helpId"
                                                            onChange={this.cambioValor}
                                                        />
                                                    </div>
                                                    <small id="helpId" className="invalid-feedback">Digite el NIC</small>
                                                </div>
                                                <div className="col-md-6">
                                                    <label htmlFor="nombre">Nombre</label>
                                                    <input style={{ textTransform: 'uppercase' }} type="text" name="nombre" id="nombre" defaultValue={cliente_especial.NOMBRE}
                                                        className={((this.verificarError("error_nombre")) ? "is-invalid" : "") + " form-control form-control-sm"} placeholder="Nombre" aria-describedby="helpId"
                                                        onChange={this.cambioValor}
                                                    />
                                                    <small id="helpId" className="invalid-feedback">Digite el Nombre</small>
                                                </div>
                                                <div className="col-md-4">
                                                    <label htmlFor="direccion">Dirección</label>
                                                    <input style={{ textTransform: 'uppercase' }} type="text" name="direccion" id="direccion" defaultValue={cliente_especial.DIRECCION}
                                                        className={((this.verificarError("error_direccion")) ? "is-invalid" : "") + " form-control form-control-sm"} placeholder="Dirección" aria-describedby="helpId"
                                                        onChange={this.cambioValor}
                                                    />
                                                    <small id="helpId" className="invalid-feedback">Digite la Dirección</small>
                                                </div>
                                            </div>
                                            <div style={{ marginTop: 0 }} className='row g-3'>
                                                <div className="col-md-3">
                                                    <label htmlFor="ID_COD_DPTO">Departamento</label>
                                                    <select name="ID_COD_DPTO" id="ID_COD_DPTO"
                                                        value={cliente_especial.ID_COD_DPTO}
                                                        options={cliente_especial.ID_COD_DPTO}
                                                        onChange={e => {
                                                            this.cargarMunicipios(e);
                                                            this.cambioValor(e)
                                                        }}
                                                        className={((this.verificarError("error_id_departamento")) ? "is-invalid" : "") + " form-select form-select-sm"}>
                                                        <option value="">Seleccione el Departamento</option>
                                                        {
                                                            departamentos.map((itemDepartamentos) => (
                                                                <option key={itemDepartamentos.ID_DEPARTAMENTO} value={itemDepartamentos.ID_DEPARTAMENTO}>{itemDepartamentos.NOMBRE}</option>
                                                            ))
                                                        }
                                                    </select>
                                                    <small id="helpId" className="invalid-feedback">Seleccione el Departamento</small>
                                                </div>
                                                <div className="col-md-3">
                                                    <label htmlFor="ID_COD_MPIO">Municipio</label>
                                                    <select name="ID_COD_MPIO" id="ID_COD_MPIO"
                                                        value={cliente_especial.ID_COD_MPIO}
                                                        options={cliente_especial.ID_COD_MPIO}
                                                        className={((this.verificarError("error_id_municipio")) ? "is-invalid" : "") + " form-select form-select-sm"}
                                                        onChange={this.cambioValor}>
                                                        <option value="">Seleccione el municipio</option>
                                                        {
                                                            municipios.map((item) => (
                                                                <option key={item.ID_MUNICIPIO} value={item.ID_MUNICIPIO}>{item.NOMBRE}</option>
                                                            ))
                                                        }
                                                    </select>
                                                    <small id="helpId" className="invalid-feedback">Seleccione el Municipio</small>
                                                </div>
                                            </div>
                                            <hr style={{ marginBottom: 0 }} />
                                            <div style={{ fontSize: 14 }} className="card-header text-center">
                                                <b>INFORMACIÓN TIPO FACTURACIÓN / TARIFA</b>
                                            </div>
                                            <div style={{ marginTop: 0 }} className='row g-3'>
                                                <div className="col-md-3">
                                                    <label htmlFor="ID_TIPO_FACTURACION">Tipo Facturación</label>
                                                    <select name="ID_TIPO_FACTURACION"
                                                        id="ID_TIPO_FACTURACION"
                                                        value={cliente_especial.ID_TIPO_FACTURACION}
                                                        options={cliente_especial.ID_TIPO_FACTURACION}
                                                        className={((this.verificarError("error_id_tipo_facturacion")) ? "is-invalid" : "") + " form-select form-select-sm"}
                                                        onChange={this.cambioValor}>
                                                        <option value="">Seleccione Tipo Facturación</option>
                                                        <option value="2">SALARIO</option>
                                                        <option value="3">UVT</option>
                                                    </select>
                                                    <small id="helpId" className="invalid-feedback">Seleccione el Tipo Facturación</small>
                                                </div>
                                                <div className="col-md-2">
                                                    <label htmlFor="tarifa">Tarifa</label>
                                                    <div className="input-group input-group-sm">
                                                        <span className="input-group-text" id="inputGroupPrepend"><FontAwesomeIcon icon={faHashtag} /></span>
                                                        <input style={{ textTransform: 'uppercase' }} type="number" name="tarifa" id="tarifa" defaultValue={cliente_especial.TARIFA}
                                                            className={((this.verificarError("error_tarifa")) ? "is-invalid" : "") + " form-control form-control-sm"} placeholder="Tarifa" aria-describedby="helpId"
                                                            onChange={this.cambioValor}
                                                        />
                                                    </div>
                                                    <small id="helpId" className="invalid-feedback">Digite la Tarifa</small>
                                                </div>
                                                <div className="col-md-2">
                                                    <label htmlFor="valor_impuesto">Valor Impuesto</label>
                                                    <div className="input-group input-group-sm">
                                                        <span className="input-group-text" id="inputGroupPrepend"><FontAwesomeIcon icon={faHashtag} /></span>
                                                        <input style={{ textTransform: 'uppercase' }} type="number" name="valor_impuesto" id="valor_impuesto" defaultValue={cliente_especial.VALOR_IMPUESTO}
                                                            className={((this.verificarError("error_tarifa")) ? "is-invalid" : "") + " form-control form-control-sm"} placeholder="Valor Impuesto" aria-describedby="helpId"
                                                            onChange={this.cambioValor} />
                                                    </div>
                                                    <small id="helpId" className="invalid-feedback">Digite el Valor Impuesto</small>
                                                </div>
                                                <div className="col-md-2">
                                                    <label htmlFor="fecha_anulacion">Fecha Anulación</label>
                                                    <div className="input-group input-group-sm">
                                                        <span className="input-group-text" id="inputGroupPrepend"><FontAwesomeIcon icon={faCalendarAlt} /></span>
                                                        <input style={{ textTransform: 'uppercase' }} type="date" name="fecha_anulacion" id="fecha_anulacion" defaultValue={cliente_especial.FECHA_ANULACION}
                                                            className={((this.verificarError("error_fecha_anulacion")) ? "is-invalid" : "") + " form-control form-control-sm"} placeholder="FECHA ANULACIÓN" aria-describedby="helpId"
                                                            onChange={this.cambioValor}
                                                        />
                                                    </div>
                                                    <small id="helpId" className="invalid-feedback">Seleccione la Fecha Anulación</small>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <hr />
                                    <div className='row'>
                                        <div className='col-xl-12 text-center'>
                                            <div className="btn-group" role="group" aria-label="">
                                                <button type="submit" className="btn btn-primary btn-sm"><FontAwesomeIcon icon={faEdit} />&nbsp;&nbsp;Editar Cliente Especial</button>&nbsp;&nbsp;
                                                <Link className="btn btn-danger btn-sm" to={"/MasterClientesEspeciales"}><FontAwesomeIcon icon={faTimes} />&nbsp;&nbsp;Cancelar</Link>
                                            </div>
                                        </div>
                                    </div>
                                </form>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default Editar;